import React from 'react';
import Tooltip from '@/app/components/Tooltip';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

interface ProposalRadioButtonsProps {
  selectedProposalType: string;
  setSelectedProposalType: (value: string) => void;
  options: { [key: string]: { type: string; tooltip: string }[] };
}

const ProposalRadioButtons: React.FC<ProposalRadioButtonsProps> = ({
  selectedProposalType,
  setSelectedProposalType,
  options,
}) => {
  return (
    <div className="flex flex-col items-start my-8 max-w-fit mx-auto">
      {Object.entries(options).map(([category, types]) => (
        <div key={category}>
          <h4
            className={`text-yellow tracking-wider ${category === 'Non-Constitutional Proposals' ? 'mt-4' : ''}`}
          >
            {category}
          </h4>
          {types.map(({ type, tooltip }) => (
            <label key={type} className="flex items-center mt-2">
              <input
                type="radio"
                name="action"
                value={type}
                checked={selectedProposalType === type}
                onChange={() => setSelectedProposalType(type)}
                className="mr-2"
              />
              {type}
              <Tooltip
                className="min-w-[175px] left-3"
                side="top"
                align="center"
                hover
                arrow
                trigger={<InformationCircleIcon className="w-5 h-5 ml-1 text-yellow" />}
              >
                <div>{tooltip}</div>
              </Tooltip>
            </label>
          ))}
        </div>
      ))}
    </div>
  );
};

export default ProposalRadioButtons;
